import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class CountryDataService {
  
  private labels:any;
 
  constructor(private httpClient: ApiHttpClient) {
  }

  checkCountryExistsAsync(code: string, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { code: code, id: id };
    return this.httpClient.getJsonAsync<boolean>('Countries/CheckCountryExists', data, timeout, false);
  }

  async getCountryStateLabelAsync(country: string, cancellationToken: Promise<any>) {
    if (!this.labels) {
      this.labels = await this.httpClient.getJsonAsync('Countries/GetCountryStateLabels', cancellationToken);
    }

    return this.labels[country.toLowerCase()];
  }
}
